import type { Transaction } from "./get-transaction";
import { RefundTransactionsListItem } from "./refund-transactions-list/refund-transactions-list-item";

export const RefundTransactionsList = ({
	transactions,
}: {
	transactions: Transaction["refundTransactions"];
}) => {
	return (
		<ul className="flex flex-col">
			{transactions?.map((transaction) => (
				<RefundTransactionsListItem key={transaction.id} {...transaction} />
			))}
		</ul>
	);
};
